import { getTrending } from "../services/OpenAiService";
import { usePaginatedFetch } from "../hooks/usePaginatedFetch";
import { FetchError } from "../errors/FetchError";
import BattlePreviewCard from "./BattlePreviewCard";
import "../App.css";

export default function TrendingBattles() {
  const { items: trending, hasMore, loading, loadingMore, error, loadMore, retry } = usePaginatedFetch(
    (offset, limit, signal) => getTrending({ offset, limit, signal }),
    { pageSize: 10, maxItems: 20 }
  );

  if (loading) {
    return (
      <div className="trending-section">
        <div className="battle-cards-grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="bpc-skeleton skeleton" />
          ))}
        </div>
      </div>
    );
  }

  if (error && trending.length === 0) {
    return (
      <div className="trending-section">
        <FetchError message="Couldn't load trending battles." onRetry={retry} />
      </div>
    );
  }

  if (trending.length === 0) return null;

  return (
    <div className="trending-section">
      <div className="battle-cards-grid">
        {trending.map((t) => (
          <BattlePreviewCard key={t.id} {...t} />
        ))}
      </div>
      {error ? (
        <div className="load-more-wrap">
          <FetchError message="Couldn't load more trending battles." onRetry={loadMore} />
        </div>
      ) : hasMore && (
        <div className="load-more-wrap">
          <button className="regen-btn" onClick={loadMore} disabled={loadingMore}>
            {loadingMore ? "Loading…" : "Load more"}
          </button>
        </div>
      )}
    </div>
  );
}
